export default __webpack_public_path__ + "static/media/icono-prod-portal.7407412d.png";